export function setAnnouncementState(state) {
  this.setState({
    isAnnouncementActive: state,
  })
}
